import { render, staticRenderFns } from "./TakipDetayView.vue?vue&type=template&id=6185b361&scoped=true"
import script from "./TakipDetayView.vue?vue&type=script&lang=ts"
export * from "./TakipDetayView.vue?vue&type=script&lang=ts"
import style0 from "./TakipDetayView.vue?vue&type=style&index=0&id=6185b361&prod&scoped=true&lang=css"
import style1 from "./TakipDetayView.vue?vue&type=style&index=1&id=6185b361&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6185b361",
  null
  
)

export default component.exports